module.exports = __webpack_public_path__ + "media/images/new_culture/comments-1-1ee86b629dfae55afd080b122266103d.jpeg";